import * as type from './constant';

export const getExecutor = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getExecutorSuccess = (payload) => ({
  type: type.GET_SUCCESS,
  payload,
});

export const getExecutorError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addExecutor = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addExecutorSuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updateExecutor = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updateExecutorSuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deleteExecutor = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deleteExecutorSuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationExecutorError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});

export const getExecutorSelf = (params = undefined, selfRole = undefined) => ({
  type: type.GET_SELF,
  selfRole,
  params,
});

export const getExecutorSelfSuccess = (payload) => ({
  type: type.GET_SELF_SUCCESS,
  payload,
});
